import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";
export const exportOredersFunc = createAsyncThunk(
    "export orders function",
    async ({ data }, thunkAPI) => {
        try {
            const response = await api.post(`/dashboard/export-orders`, data);
            return response;
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }

    }
)

const exportOredersSlicer = createSlice({
    name: "export orders slicer",
    initialState: {
        loading: null,
        course: null,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(exportOredersFunc.pending, (state) => {
            state.loading = true
            state.course = {}
            state.error = false
        });
        builder.addCase(exportOredersFunc.rejected, (state) => {
            state.loading = false
            state.course = {}
            state.error = true
        });
        builder.addCase(exportOredersFunc.fulfilled, (state, action) => {
            state.loading = false
            state.course = action.payload
            state.error = false
        });
    }
});

export default exportOredersSlicer.reducer;